import React from 'react';
import { Link } from 'react-router-dom';

// ══════════════════════════════════════════════════════════════
// LOGO PEFEP SITE — composant unique réutilisé dans toutes les navbars.
// On le change ICI une seule fois → il se met à jour partout.
//
// Les images sont dans le dossier public/ (servies par leur URL),
// donc on les référence directement — pas d'import.
//   public/logo-pefep-site.png        → fonds CLAIRS (texte foncé)
//   public/logo-pefep-site-blanc.png  → fonds FONCÉS (texte blanc)
//
// Props :
//   - sombre  : true si le logo est posé sur un fond FONCÉ (navbar bleue/dark)
//   - hauteur : hauteur en pixels (défaut 40)
//   - lien    : destination du clic (défaut '/'), passe null pour désactiver
// ══════════════════════════════════════════════════════════════

const LOGO_CLAIR = process.env.PUBLIC_URL + '/logo-pefep-site.png';
const LOGO_FONCE = process.env.PUBLIC_URL + '/logo-pefep-site-blanc.png';

export default function LogoPefep({ sombre = false, hauteur = 40, lien = '/' }) {
  const src = sombre ? LOGO_FONCE : LOGO_CLAIR;
  const img = (
    <img
      src={src}
      alt="PEFEP Site"
      style={{ height: hauteur, width: 'auto', display: 'block' }}
    />
  );

  if (!lien) return img;
  return (
    <Link to={lien} aria-label="PEFEP Site" style={{ display: 'inline-flex', alignItems: 'center' }}>
      {img}
    </Link>
  );
}